import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useMoney } from '../../context/CurrencyContext';
import { filsToAed } from '../../lib/engine';

const COLORS = ['hsl(var(--chart-1))', 'hsl(var(--chart-2))', 'hsl(var(--chart-3))', 'hsl(var(--chart-4))',
  'hsl(var(--chart-5))', 'hsl(var(--teal))', 'hsl(var(--copper))', 'hsl(var(--muted-foreground))'];

export function CostMixDonut({ costMix }) {
  const { moneyLabel } = useMoney();
  const { data, total } = useMemo(() => {
    const rows = Object.entries(costMix).map(([name, v]) => ({ name, value: filsToAed(v), fils: v }))
      .filter((d) => d.value > 0);
    return { data: rows, total: rows.reduce((a, d) => a + d.value, 0) };
  }, [costMix]);
  // Legend is a sorted copy (never mutate `data` in place during render).
  const legend = useMemo(() => [...data].sort((a, b) => b.value - a.value).slice(0, 6), [data]);
  if (!total) return <div className="py-6 text-center text-xs text-muted-foreground">No cost data yet.</div>;
  return (
    <div className="flex items-center gap-3">
      <div className="relative h-32 w-32 shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" innerRadius={42} outerRadius={62} paddingAngle={2} stroke="none">
              {data.map((e, i) => <Cell key={e.name ?? i} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip contentStyle={{ backgroundColor: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: 12, fontSize: 11 }}
              formatter={(v) => moneyLabel(v * 100, 0)} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="min-w-0 flex-1 space-y-1">
        {legend.map((d, i) => (
          <div key={d.name} className="flex items-center gap-2 text-[11px]">
            <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: COLORS[Object.keys(costMix).indexOf(d.name) % COLORS.length] }} />
            <span className="truncate text-muted-foreground">{d.name}</span>
            <span className="money ml-auto">{((d.value / total) * 100).toFixed(0)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
